<div class="mat-h2" mat-dialog-title><span>{{'UserDetails'|translate}}</span><div class="spacer"></div><span><mat-icon mat-dialog-close class="pointer">close</mat-icon></span></div>
<div class="content">
    <div>
        <app-user-info
            (loader)="setLoading($event)"
            [bordercss]="true"
        >
        </app-user-info>
    </div>
    <div>
        <app-user-detail
            [clientId]="data?.clientId"
        >
        </app-user-detail>
    </div>
</div>
<app-spinner [class.hide]="!loading"></app-spinner>

